

import { useTranslation } from "react-i18next";
import { useQuery } from "react-query";

import { getNationalities } from "../../../../../MyApi/sb/natonalities"

import SingleNationality from "../singleNationality";
import LoadingSpinner from "../../../../UI/spinner";


import NoData from "../../../../UI/nodata";
import ErrorMessage from "../../../../UI/error";

import classes from "../../../../../assets/css/globalDataTable.module.css";

const NationalitiesDataTable = () => {
const {data , isLoading ,refetch,error } = useQuery("getNationalites" ,getNationalities)
const {t} = useTranslation()

const nationalities = data?.data || []
const responeMessage= data?.message

if(isLoading){
    return <LoadingSpinner/>
}
if(error){  
  return <ErrorMessage  error={error}/>
}
if(nationalities.length === 0){
  return<NoData  responeMessage={responeMessage}/>
}


if(!data){
    return <div>no data available</div>
}
  return (
    <div className="container-fluid"> 
      <div className="card">
        <div className="table-responsive-sm">
        <table className="table-responsive-sm table table-striped table-hover">
            <thead className={classes.tableHeader}>    
            <th>#</th> 
            <th>{t("Name")}</th>
            <th>{t("Image")}</th>
            <th>{t("Active")}</th>  
            <th>{t("Actions")}</th>
            </thead>
          <tbody>
          {nationalities.map((nationality)=> ( <SingleNationality key={nationality.id}  nationality={nationality}  classes={classes} refetch={refetch}/>))   }
          </tbody>
        </table> 
        </div>
        </div>
         
    </div>
  );
};

export default NationalitiesDataTable;
